<template>
    <div>
        <div class="sharePanel">
            <div style="padding:20px" id="canvas_area"></div>
            <div id="temp_area"></div>
        </div>
        <div class="share_progress" v-if="showProgress">
            <el-progress :percentage="nowProgress"></el-progress>
        </div>
        <div ref="printBox" style="position: fixed; left: -9999px; top: 0; width: 100%;"></div>
        <el-dialog title="选择字段" :visible.sync="tagDialog" width="60%">
            <el-checkbox-group border v-model="shareType">
                <el-checkbox style="margin-bottom:5px" v-for="(tag,index) in tagList" :label="tag.id" :key="index">{{tag.label}}</el-checkbox>
            </el-checkbox-group>
            <div v-if="showType==0" style="display: flex;align-items: center;padding-top: 20px;">
                <span style="padding-right: 5px;">打印客户备注</span>
                <el-switch
                    :active-value="1"
                    :inactive-value="0"
                    v-model="showCustRemark">
                </el-switch>
            </div>
            <div style="margin-top:20px;text-align:center">
                <el-button type="primary" @click="startPrint()">确认</el-button>
                <el-button @click="tagDialog=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props:{
        otherShowList:{
            type:Array,
            default:function(){
                return [];
            }
        }
    },
    components: {
    },
    data() {
        return {
            showType:-1,
            desc:'订单',
            showProgress:false,
            maxCount:0,
            nowProgress:0,
            searchLimit:"",
            shareType:[],
            tagList:[],
            tagDialog:false,
            showCustRemark:0,
            printBox:null,
        };
    },
    created() {
        if(this.$global.userType===0){
            this.$api.getDataStorage({key:'orderDetailshowCustRemark',share:1}).then(res=>{
                if(res.data.data&&res.data.data.orderDetailshowCustRemark==1){
                    this.showCustRemark = 1;
                }else{
                    this.showCustRemark = 0;
                }
            })
        }
    },
    methods: {
        openList(ids,val,searchObj){
            this.arr = ids;
            let temp = val?val:0;
            if(temp!=this.showType){
                this.tagList = [];
                this.shareType = [];
                this.showType = temp;
                if(this.showType==0){
                    this.desc = "订单";
                    this.tagList.push({id:'index',label:'序号'},{id:'pnumber',label:'产品编号'},{id:'prod',label:'产品'}
                    ,{id:'punit',label:'单位'},{id:'price',label:'单价'},{id:'sendstate',label:'已发'},{id:'amount',label:'数量'}
                    ,{id:'unit',label:'总数'},{id:'money',label:'总金额'},{id:'remark',label:'备注'},{id:'udate',label:'修改日期'}
                    );
                    this.shareType.push('index','pnumber','prod','punit','price','sendstate','amount','unit','money','remark');
                }else if(this.showType==1){
                    this.desc = "销售单";
                    this.tagList.push({id:'index',label:'序号'},{id:'pnumber',label:'产品编号'},{id:'prod',label:'产品'}
                    ,{id:'amount',label:'件数'},{id:'parts',label:'零头'},{id:'price',label:'单价'},{id:'unit',label:'双数'}
                    ,{id:'cancelUnit',label:'退货'},{id:'money',label:'总金额'},{id:'oremark',label:'订单备注'}
                    ,{id:'wname',label:'仓库'},{id:'remark',label:'备注'});
                    this.shareType.push('index','pnumber','prod','amount','parts','unit','cancelUnit','money','wname','remark');
                }else if(this.showType==2){
                    this.desc = "客户未发货统计";
                    this.tagList.push({id:'index',label:'序号'},{id:'cust',label:'客户'},{id:'prod',label:'产品'}
                    ,{id:'price',label:'单价'},{id:'amount',label:'订货'},{id:'unit',label:'订货双数'}
                    ,{id:'money',label:'总额'},{id:'sendedAmount',label:'已发'},{id:'sendedUnit',label:'已发双数'}
                    ,{id:'notSendAmount',label:'未发'},{id:'notSendUnit',label:'未发双数'},{id:'remark',label:'备注'});
                    this.shareType.push('index','cust','prod','price','amount','money','sendedAmount','notSendAmount','remark');
                }else if(this.showType==3){
                    this.desc = "员工未发货统计";
                    this.tagList.push({id:'index',label:'序号'},{id:'emp',label:'销售员'},{id:'prod',label:'产品'}
                    ,{id:'price',label:'单价'},{id:'cust',label:'客户'},{id:'amount',label:'订货'},{id:'unit',label:'订货双数'}
                    ,{id:'money',label:'总额'},{id:'sendedAmount',label:'已发'},{id:'sendedUnit',label:'已发双数'}
                    ,{id:'notSendAmount',label:'未发'},{id:'notSendUnit',label:'未发双数'},{id:'remark',label:'备注'});
                    this.shareType.push('index','emp','prod','price','cust','amount','money','sendedAmount','notSendAmount','remark');
                }else if(this.showType==4){
                    this.desc = "产品未发货统计";
                    this.tagList.push({id:'index',label:'序号'},{id:'prod',label:'产品'},{id:'price',label:'单价'}
                    ,{id:'cust',label:'客户'},{id:'amount',label:'订货'},{id:'unit',label:'订货双数'}
                    ,{id:'sendedAmount',label:'已发'},{id:'sendedUnit',label:'已发双数'}
                    ,{id:'notSendAmount',label:'未发'},{id:'notSendUnit',label:'未发双数'},{id:'remark',label:'备注'});
                    this.shareType.push('index','prod','price','cust','amount','sendedAmount','notSendAmount','remark');
                }else if(this.showType==5){
                    this.desc = "应收报表";
                    this.tagList.push({id:'cnumber',label:'客户'},{id:'category',label:'客户类别'},{id:'beginbill',label:'期初欠款'}
                    ,{id:'sumAmount',label:'销售数量'},{id:'sumUnit',label:'销售双数'},{id:'total',label:'销售金额'}
                    ,{id:'pay',label:'收款'},{id:'free',label:'免除'},{id:'needPay',label:'应收'});
                    this.shareType.push('cnumber','category','beginbill','sumAmount','sumUnit','total','pay','free','needPay');
                }else if(this.showType==6){
                    this.desc = "客户对账单";
                    this.tagList.push({id:'index',label:'序号'},{id:'sdate',label:'开单时间'},{id:'completeDate',label:'发货时间'}
                    ,{id:'sdnumber',label:'发货单'},{id:'pnumber',label:'货号'},{id:'pname',label:'品名'},{id:'color',label:'颜色'}
                    ,{id:'size',label:'尺码'},{id:'amount',label:'数量'},{id:'punit',label:'装箱数量'},{id:'unit',label:'发货双数'}
                    ,{id:'cancelUnit',label:'退货数'},{id:'price',label:'单价'},{id:'money',label:'总价'},{id:'remark',label:'备注'}
                    ,{id:'oremark',label:'订单备注'}
                    );
                    if(this.otherShowList&&this.otherShowList.length>0){
                        this.shareType.push(...this.otherShowList);
                    }else{
                        this.shareType.push('index','sdate','pnumber','pname','color','size','amount','punit','unit','price','money','oremark');
                    }
                }else if(this.showType==7){
                    this.desc = "收款记录";
                }else if(this.showType==8){
                    this.desc = "收支记录";
                }else if(this.showType==9){
                    this.desc = "库存明细";
                    this.tagList.push({id:'pnumber',label:'货号'},{id:'pname',label:'名称'},{id:'sp',label:'属性'}
                    ,{id:'unit',label:'单位'},{id:'inStock',label:'总入库'},{id:'inStockUnit',label:'总入库双数'}
                    ,{id:'od',label:'订货'},{id:'odUnit',label:'订货双数'},{id:'sended',label:'已发'},{id:'sendedUnit',label:'已发双数'}
                    ,{id:'notSend',label:'未发'},{id:'notSendUnit',label:'未发双数'},{id:'stock',label:'库存'}
                    ,{id:'stockUnit',label:'库存双数'},{id:'sprice',label:'单价'},{id:'sumPrice',label:'总价'});
                    this.shareType.push('pnumber','sp','unit','inStock','od','sended','notSend','stock');
                }else if(this.showType==10){
                    this.desc = "出入库汇总";
                    this.tagList.push({id:'index',label:'序号'},{id:'prod',label:'商品'},{id:'spec',label:'辅助属性'}
                    ,{id:'price',label:'单价'},{id:'packing',label:'包装单位'},{id:'wname',label:'仓库'}
                    ,{id:'inAmount',label:'入库数量'},{id:'inPrice',label:'入库金额'},{id:'outAmount',label:'出库数量'}
                    ,{id:'outPrice',label:'出库金额'},{id:'editAmount',label:'库存更改'},{id:'editPrice',label:'更改金额'});
                    this.shareType.push('index','prod','spec','price','packing','wname','inAmount','inPrice','outAmount','outPrice','editAmount','editPrice');
                }else if(this.showType==11){
                    this.desc = "入库明细";
                    this.tagList.push({id:'index',label:'序号'},{id:'date',label:'日期'},{id:'ename',label:'操作人员'}
                    ,{id:'cname',label:'指定客户'},{id:'wname',label:'仓库'},{id:'prod',label:'商品'}
                    ,{id:'spec',label:'辅助属性'},{id:'packing',label:'包装单位'},{id:'price',label:'单价'}
                    ,{id:'oper',label:'业务类型'},{id:'inAmount',label:'入库数量'},{id:'inPrice',label:'入库金额'}
                    ,{id:'outAmount',label:'出库数量'},{id:'outPrice',label:'出库金额'},{id:'editAmount',label:'库存更改'}
                    ,{id:'editPrice',label:'更改金额'},{id:'oremark',label:'订单备注'},{id:'note',label:'备注'});
                    this.shareType.push('index','date','cname','prod','packing','price','inAmount','inPrice');
                }else if(this.showType==12){
                    this.desc = "出库明细";
                    this.tagList.push({id:'index',label:'序号'},{id:'date',label:'日期'},{id:'ename',label:'操作人员'}
                    ,{id:'cname',label:'指定客户'},{id:'wname',label:'仓库'},{id:'prod',label:'商品'}
                    ,{id:'spec',label:'辅助属性'},{id:'packing',label:'包装单位'},{id:'price',label:'单价'}
                    ,{id:'oper',label:'业务类型'},{id:'inAmount',label:'入库数量'},{id:'inPrice',label:'入库金额'}
                    ,{id:'outAmount',label:'出库数量'},{id:'outPrice',label:'出库金额'},{id:'editAmount',label:'库存更改'}
                    ,{id:'editPrice',label:'更改金额'},{id:'oremark',label:'订单备注'},{id:'note',label:'备注'});
                    this.shareType.push('index','date','cname','prod','packing','price','outAmount','outPrice');
                }else if(this.showType==13){
                    this.desc = "更改明细";
                    this.tagList.push({id:'index',label:'序号'},{id:'date',label:'日期'},{id:'ename',label:'操作人员'}
                    ,{id:'cname',label:'指定客户'},{id:'wname',label:'仓库'},{id:'prod',label:'商品'}
                    ,{id:'spec',label:'辅助属性'},{id:'packing',label:'包装单位'},{id:'price',label:'单价'}
                    ,{id:'oper',label:'业务类型'},{id:'inAmount',label:'入库数量'},{id:'inPrice',label:'入库金额'}
                    ,{id:'outAmount',label:'出库数量'},{id:'outPrice',label:'出库金额'},{id:'editAmount',label:'库存更改'}
                    ,{id:'editPrice',label:'更改金额'},{id:'oremark',label:'订单备注'},{id:'note',label:'备注'});
                    this.shareType.push('index','date','cname','prod','packing','price','editAmount','editPrice');
                }else if(this.showType==14){
                    this.desc = "采购单";
                    this.tagList.push({id:'index',label:'序号'},{id:'mnumber',label:'产品编号'},{id:'material',label:'产品'}
                    ,{id:'amount',label:'采购数量'},{id:'price',label:'开单单价'},{id:'money',label:'开单总价'}
                    ,{id:'present',label:'现金单价'},{id:'presentMoney',label:'现金总价'},{id:'remark',label:'备注'});
                    this.shareType.push('index','mnumber','material','amount','price','money','remark');
                }else if(this.showType==15){
                    this.desc = "采购退货单";
                    this.tagList.push({id:'index',label:'序号'},{id:'mnumber',label:'产品编号'},{id:'material',label:'产品'}
                    ,{id:'amount',label:'退货数量'},{id:'price',label:'单价'},{id:'money',label:'总价'},{id:'remark',label:'备注'});
                    this.shareType.push('index','mnumber','material','amount','price','money','remark');
                }else if(this.showType==16){
                    this.desc = "材料入库单";
                    this.tagList.push({id:'index',label:'序号'},{id:'mnumber',label:'产品编号'},{id:'material',label:'产品'}
                    ,{id:'amount',label:'入库数量'},{id:'price',label:'单价'},{id:'money',label:'总价'},{id:'remark',label:'备注'});
                    this.shareType.push('index','mnumber','material','amount','price','money','remark');
                }else if(this.showType==17){
                    this.desc = "领料出库单";
                    this.tagList.push({id:'index',label:'序号'},{id:'mnumber',label:'产品编号'},{id:'material',label:'产品'}
                    ,{id:'amount',label:'领料数量'},{id:'price',label:'单价'},{id:'money',label:'总价'},{id:'remark',label:'备注'});
                    this.shareType.push('index','mnumber','material','amount','price','money','remark');
                }
            }
            let len = this.arr.length;
            this.maxCount = len;
            if(searchObj){
               let arr =  Object.keys(searchObj);
               let str = [];
               for(let i in arr){
                   str.push(arr[i]+"="+encodeURIComponent(searchObj[arr[i]]));
               }
               this.searchLimit = str.join('&');
            }else{
                this.searchLimit = "";
            }
            if(len>0){
                if(this.tagList.length>0){
                    this.tagDialog = true;
                }else{
                    this.startPrint();
                }
            }
        },
        startPrint(){
            this.tagDialog = false;
            this.showProgress = true;
            this.checkEnd();
        },
        checkEnd(){
            this.nowProgress = Math.floor(((this.maxCount-this.arr.length)/this.maxCount)*100);
            if(this.arr.length>0){
                let id = this.arr.shift();
                var path = "";
                if(this.showType==0){
                    var beforeUrl = "/emp/print/printOrder?id=";
                    var afterUrl = '&columns=' + encodeURIComponent(this.shareType.join(',')) +'&template=1&showCustRemark='+this.showCustRemark;
                    path = this.$api.baseURL + beforeUrl + id + afterUrl;
                }else if(this.showType==1){
                    var beforeUrl = "/emp/print/printOrderSend?id=";
                    var afterUrl = "&columns="+encodeURIComponent(this.shareType.join(','))+"&showDetail=0";
                    path = this.$api.baseURL + beforeUrl + id + afterUrl;
                }else if(this.showType==2){
                    path = this.$api.baseURL + '/emp/print/printOrderByCust?'+this.searchLimit+'&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==3){
                    path = this.$api.baseURL + '/emp/print/printOrderByEmp?'+this.searchLimit+'&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==4){
                    path = this.$api.baseURL + '/emp/print/printOrderByProd?'+this.searchLimit+'&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==5){
                    path = this.$api.baseURL + '/emp/print/printNeedPayment?'+this.searchLimit+'&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==6){
                    path = this.$api.baseURL + '/emp/print/printCustomerPayment?'+this.searchLimit+'&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==7){
                    path = this.$api.baseURL + '/emp/print/printPayment?'+this.searchLimit+'&showDetail=0';
                }else if(this.showType==8){
                    path = this.$api.baseURL + '/emp/print/printOtherPayment?'+this.searchLimit+'&showDetail=0';
                }else if(this.showType==9){
                    path = this.$api.baseURL + '/emp/print/printStock?'+this.searchLimit+'&token='+encodeURIComponent(localStorage.getItem("token"))+'&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==10){
                    path = this.$api.baseURL + '/emp/print/printStockReport?'+this.searchLimit+'&token='+encodeURIComponent(localStorage.getItem("token"))+'&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==11){
                    path = this.$api.baseURL + '/emp/print/printStockDetail?'+this.searchLimit+'&token='+encodeURIComponent(localStorage.getItem("token"))+'&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==12){
                    path = this.$api.baseURL + '/emp/print/printStockDetail?'+this.searchLimit+'&token='+encodeURIComponent(localStorage.getItem("token"))+'&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==13){
                    path = this.$api.baseURL + '/emp/print/printStockDetail?'+this.searchLimit+'&token='+encodeURIComponent(localStorage.getItem("token"))+'&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==14||this.showType==15){
                    path = this.$api.baseURL + '/emp/print/printMaterialOrder?id='+id+'&template=1&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }else if(this.showType==16||this.showType==17){
                    path = this.$api.baseURL + '/emp/print/printRecordHead?id='+id+'&template=1&columns='+encodeURIComponent(this.shareType.join(','))+'&showDetail=0';
                }
                if(path){
                    const printWin = window.open(path, "_blank");
                    printWin.onload = () => {
                        setTimeout(() => {
                            printWin.print();
                        }, 500);
                    };
                }
            }
        },
    },
};
</script>
<style scoped>
.share_progress{
    width: 400px;
    padding: 20px;
    border-radius: 10px;
    background-color: #f5f5f5;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
}
.sharePanel{
    width: 1024px;
    height: 100%;
    position: fixed;
    top:0px;
    left:-1024px;
}
</style>